var React = require('react');

function StopBtnInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M0.628906 61.645V4.59701C0.628906 2.1297 2.51568 0.242004 4.98391 0.242004H15.4349C17.7574 0.242004 19.6442 2.12878 19.6442 4.59701V61.645C19.6442 63.9674 17.7574 66 15.4349 66H4.98391C2.5166 66 0.628906 63.9674 0.628906 61.645ZM32.1278 61.645V4.59701C32.1278 2.1297 34.1604 0.242004 36.4828 0.242004H46.9339C49.4012 0.242004 51.2889 2.12878 51.2889 4.59701V61.645C51.2889 63.9674 49.4021 66 46.9339 66H36.4828C34.1604 66 32.1278 63.9674 32.1278 61.645Z","fill":"white"}));
}

StopBtnInline.defaultProps = {"width":"52","height":"66","viewBox":"0 0 52 66","fill":"none"};

module.exports = StopBtnInline;

StopBtnInline.default = StopBtnInline;
